export enum VariableTypes {
  Time,
}
